<template>
	<div class="mapBox">
		<div class="map">
			<baidu-map class="mapGoogle" id="map" :center="center" :zoom="zoom" @ready="handler"></baidu-map>
			<div class="nav" :style="{left:navShow?'0':'-310px'}">
				<div class="btn" @click="navShow=!navShow">
					{{navShow?'收起':'展开'}}				
					<img :style="{transform:navShow?'rotate(0deg)':'rotate(180deg)'}" src="./img/hsj.png"></div>
				<h3>大救星全球地图</h3>
				<ul class="height" v-show="!detailsShow">
					<li v-for="item in cityAll">
						<div class="listBox" @click="item.childShow=!item.childShow">
							<p>{{item.name}}</p>
							<img :class="{active:item.childShow}" src="./img/jiantou.png">							
						</div>
						<ul class="guangjiaList" v-show="item.childShow">
							<li class="guojia" v-for="item in item.city" @click="detailsShow=!detailsShow;setCenter(item)">
								<div class="top">
									<img :src="item.country.nationalFlag">
									<div class="zhishu">
										<p>{{item.country.countryName}}</p>
										<p>
											<span class="text">风险指数</span>
											<span class="xing">
												<img src="./img/xingxing.png" v-for="item in item.riskLevel">
												<img src="./img/xingxing1.png" v-for="item in 5-item.riskLevel">
											</span>
										</p>
									</div>
								</div>
								<div class="fuwushang">
									<p class="icon1">服务商</p>
									<p>{{item.supplierCount}}</p>
								</div>
								<div class="fuwushang">
									<p class="icon2">星使</p>
									<p>{{item.xingshiCount}}</p>
								</div>
							</li>
						</ul>
					</li>
				</ul>
				<div class="height detailsBox" v-if="detailsShow">
					<p class="back" @click="detailsShow=!detailsShow;backFun()">返回</p>
					<div class="box">
						<div class="top" @click="checkMack(0)">
							<img :src="countryDetailCity.country.nationalFlag">
							<div class="zhishu">
								<p>{{countryDetailCity.country.countryName}}</p>
								<p>
									<span class="text">风险指数</span>
									<span class="xing">
										<img src="./img/xingxing.png" v-for="item in countryDetailCity.riskLevel">
										<img src="./img/xingxing1.png" v-for="item in 5-countryDetailCity.riskLevel">
									</span>
								</p>
							</div>
						</div>
						<div class="fuwushangBox" :class="{active:activeIndex == 1}" @click="checkMack(1)">
							<p>当地签约服务商</p>
							<div class="fuwushang">
								<p class="icon1">服务商（分布<span> {{countryDetail.suDistributed}} </span>城市）</p>
								<p>{{countryDetailCity.supplierCount}}</p>
							</div>
						</div>
						<div class="fuwushangBox" :class="{active:activeIndex == 2}"  @click="checkMack(2)">
							<p>驻当地星使</p>
							<div class="fuwushang">
								<p class="icon2">星使（分布<span>{{countryDetail.xsDistributed}}</span>城市）</p>
								<p>{{countryDetailCity.xingshiCount}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="liebiaoBox" @click="listFun" v-show="detailsShow">
				<p>列表展示</p>
			</div>
			<listBox 
				ref=listBox 
				class='positionBottom' 
				v-show='fuwuShow' 
				@listBox=listBox 
				:countryDetail=countryDetail 
				:countryCode=countryCodeArr
				:countryCodeXs=countryCodeXs
				></listBox>
		</div>
	</div>
</template>
<script>
	import listBox from './list';
	import xingshi from "./img/xingshi.png"
	import fuwushang from "./img/fuwushang.png"
	import centerImg from "./img/center.png"
	import { getlistByContinent,getlistCountryDetail,getlistCountryCode,getlistCountryCodeXs } from '@/views/axios/api.js';
	export default{
		data(){
			return {
				navShow:false,//侧导航是否显示
				listShow:false,
				detailsShow:false,//详情
				fuwuShow:false,//列表展示
				mapNode:null,
				nodeList:[],
				cityAll: [],
				countryDetail:[],//城市详情
				countryDetailCity:{},//
				
				xignshiList:[],//星使
				countryCode:'',
				countryCodeArr:'',
				countryCodeXs:'',
				coldId:'',
				countryMarker:[],//国家标记
				countryInfowindow:[],//标记信息
				fuwushangMarker:[],//服务商标记
				fwInfowindow:[],//标记信息
				xingshiMarker:[],//星使标记
				xsInfowindow:[],//标记信息
        activeIndex:0,
        center: {lng: 35.7, lat: 101.416667},
        zoom: 3
			}
		},
		components: {
      listBox
    },
		mounted() {
      var index =0;
      // this.init();
			// var timer =setInterval(() => {
			// 	index++
			// 	if(typeof google == 'object'){
			// 		clearInterval(timer)
			// 		this.init()
			// 	}
			// 	if(index > 15){
			// 		location.reload('/map')
			// 	}
			// },300)
		},
		methods:{
      //百度地图初始化
      handler ({BMap, map}) {
        // var _this = this;
        this.mapNode = map;
        //自定义地图的显示范围：中国区域内部
        map.centerAndZoom(new BMap.Point(101.416667, 35.7), 3);
	      map.enableScrollWheelZoom();  
        var strictBounds = new BMap.Bounds(new BMap.Point(66.28120434863283, 14.48003790418668),new BMap.Point(143.71284497363283, 54.44617552862156 ));  
        // try {
        //   BMapLib.AreaRestriction.setBounds(map, strictBounds);
        // } catch (e) {
        //   alert(e);
        // }
        this.mapNode.addEventListener('dragend',  
          function() { 
            if(map)
            {
              // console.log(map.getBounds().getNorthEast().lng)
              var maxX = map.getBounds().getNorthEast().lng;
              var maxY = map.getBounds().getNorthEast().lat;
              var minX = map.getBounds().getSouthWest().lng;
              var minY = map.getBounds().getSouthWest().lat;
              if (maxY > 85.2 || minY < -85){
                map.panTo(new BMap.Point(0.580078125, 35.05859375));
                return;
              }
            }
          }
        );				
        this.getlistByContinent();
        // var point = new BMap.Point(14.48003790418668, 143.71284497363283)
        // map.centerAndZoom(point, 3)
        // var marker = new BMap.Marker(point) // 创建标注
        // map.addOverlay(marker) // 将标注添加到地图中
        // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
        // map.addOverlay(circle)
      },
      listBox(){					
        this.$refs.listBox.animatFun(false)
        setTimeout(()=>{
          this.fuwuShow=false;
        },250)				
      },
      listFun(){
        this.fuwuShow=!this.fuwuShow;
        setTimeout(()=>{
          this.$refs.listBox.animatFun(true)
        },20)
      },
      init({BMap, map}){//初始化地图
            //中心点设置
            // var mapa = new BMap.Map("map");
        var _this=this;
        var center={lat: 35.7, lng: 101.416667}
        this.mapNode = new google.maps.Map(document.getElementById('map'), {
          center,
          minZoom:3,
          zoom: 3
        });	
        //自定义地图的显示范围：中国区域内部  
        var strictBounds = new google.maps.LatLngBounds(  
            new google.maps.LatLng(14.48003790418668, 66.28120434863283),   
            new google.maps.LatLng(54.44617552862156, 143.71284497363283  
        ));  
        google.maps.event.addListener(this.mapNode, 'dragend',  
        function() { 
              if(_this.mapNode)
              {
                var maxX = _this.mapNode.getBounds().getNorthEast().lng();
                var maxY = _this.mapNode.getBounds().getNorthEast().lat();
                var minX = _this.mapNode.getBounds().getSouthWest().lng();
                var minY = _this.mapNode.getBounds().getSouthWest().lat();
                if (maxY > 85.2 || minY < -85){
                  _this.mapNode.panTo(new google.maps.LatLng(35.05859375, 0.580078125));
                  return;
                }
              }
        });				
        this.getlistByContinent();
      },
      mapFun(){
        //点击弹窗提示
        var _this=this;
        function content(data){
          // var contentString =`<div class='promptBox'>
          //             <div class='top'>
          //               <img src='${data.country.nationalFlag}'>
          //               <p>${data.country.countryName}</p>
          //             </div>
          //             <div class='icon'>
          //               <span>${data.supplierCount}</span>
          //               <span>${data.xingshiCount}</span>
          //               <a class='details' target='_self' href='map?id=${JSON.stringify(data)}'>详情</a>
          //             </div>
          //           </div>`;
                    var contentString =`<div class='promptBox'>
                      <div class='top'>
                        <img src='${data.country.nationalFlag}'>
                        <p>${data.country.countryName}</p>
                      </div>
                      <div class='icon'>
                        <span>${data.supplierCount}</span>
                        <span>${data.xingshiCount}</span>
                      </div>
                    </div>`;
          return contentString
        }
        //标记设置
        this.nodeList.forEach((feature,index)=> {
          var opts = {
            width : 150, 
            height: 80, 
            map: this.mapNode,
            icon: centerImg,
            enableMessage:true
          };
          var point = new BMap.Point(feature.country.lng, feature.country.lat);
          var marker = new BMap.Marker(point);
          this.mapNode.addOverlay(marker); 
          marker.addEventListener('click', function(e) {
            var infowindow = new BMap.InfoWindow(content(feature),opts);	
            _this.mapNode.openInfoWindow(infowindow,new BMap.Point(e.point.lng, e.point.lat));
          });
          _this.countryMarker.push({marker})
        });
      },
			getlistByContinent(){
				if(this.cityAll.length != 0) return this.mapFun()
				getlistByContinent()
				.then(res => {
					var arr1=[],arr2=[],arr3=[],arr4=[],arr5=[],arr6=[]
					this.nodeList = res.data.obj.filter(item => {
						return item.supplierCount != 0 || item.xingshiCount !=0
					})
					this.nodeList.forEach(item => {
						switch (item.continent){
							case 1:
								arr1.push(item)
							break;
							case 2:
								arr2.push(item)
							break;
							case 3:
								arr3.push(item)
							break;
							case 4:
								arr4.push(item)
							break;
							case 5:
								arr5.push(item)
							break;
							default:
								arr6.push(item)
								break;							
						}						
					})
					this.cityAll.push({name:'亚洲',city:arr1,childShow:false})
					this.cityAll.push({name:'欧洲',city:arr2,childShow:false})
					this.cityAll.push({name:'非洲',city:arr3,childShow:false})
					this.cityAll.push({name:'大洋洲',city:arr4,childShow:false})
					this.cityAll.push({name:'北美洲',city:arr5,childShow:false})
					this.cityAll.push({name:'南美洲',city:arr6,childShow:false})
					this.mapFun()
				})
				.catch(err => {
					console.log(err)
				})
			},
			setCenter(value){
        console.log(value,'在setCenter找到this.mapnode')
				this.mapNode.setCenter(new BMap.Point(value.country.lng, value.country.lat))
				this.mapNode.setZoom(10);
				
				this.getlistCountryDetail(value.country.countryCode.replace(/\s*/g,""))
				this.countryDetailCity=value;//赋值
			},
			backFun(){
        var map = this.mapNode;
				//清空
				this.$router.push({path:'/map'})
				this.fuwushangMarker.forEach((item,index)=>{
          // this.fuwushangMarker[index].marker.setMap(null)
          map.removeOverlay(this.xingshiMarker[index]);
				})	
				this.xingshiMarker.forEach((item,index)=>{
          // this.xingshiMarker[index].marker.setMap(null)
          map.removeOverlay(this.xingshiMarker[index]);
				})	
				this.checkMack(0)
				// this.init()
				this.countryDetailCity={}//清空
				this.countryDetail=[];
				
			},
			getlistCountryDetail(countryCode){
        var map = this.mapNode;
				var data={
					countryCode
				}
				getlistCountryDetail(data)//服务商，星使列表
				.then(res => {
          console.log(res,'服务商，星使列表')
					this.countryDetail=res.data.obj;
					this.countryMarker.forEach((item,index)=>{
            // this.countryMarker[index].marker.setMap(null)
            map.removeOverlay(this.countryMarker[index]);
					})
					this.fuCoordinates()
				})
				.catch(err => {
					console.log(err)
				})
				getlistCountryCode(data)//服务商判断是否正在进行
				.then(res => {
          console.log(this.countryCodeArr,'循环报错的数据看是否是空')
					this.countryCodeArr=res.data.obj
				})
				.catch(err => {
					console.log(err)
				})
				getlistCountryCodeXs(data)//星使判断正在进行
				.then(res => {
					this.countryCodeXs=res.data.obj
				})
				.catch(err => {
					console.log(err)
				})
			},
			fuCoordinates(coordinates){
        console.log('列表单个点击')
        //点击弹窗提示
        var _this=this;
        function content(data){
          console.log(data,'我的fuCoordinates data')
          var liList='';
          data.forEach(item => {
            liList+=`<li>
              <img class='fuImg' src='${item.logo}'>
              <div class='fuName'>
                <p>${item.name}</p>
                <p>${item.category}</p>
              </div>
            </li>`
          })
          var contentString =`<div class='promptBox'>
                  <p class='fuWu'>服务商</p>
                  <ul>${liList}</ul>
                    </div>`;
          return contentString
        }
		        	
        function content1(data){
          var contentString =`<div class='promptBox'>
                  <p class='fuWu'>星使</p>
                  <ul>
                    <li>
                      <img class='xsImg' src='${data.basic.portrait}'>
                          <p class='xstext'>${data.basic.realName}</p>
                    </li>
                  </ul>
                    </div>`;
          return contentString
        }		        	
        //服务商标记
        this.countryDetail.citydetails.forEach(item => {
          if(item.institutes.length == 0) return
          var opts = {
            width : 150,
            height: 80,
            enableMessage:true
          };
          var point = new BMap.Point(item.city.lng, item.city.lat);
          var marker = new BMap.Marker(point);
          _this.mapNode.addOverlay(marker);
          var infowindow = new BMap.InfoWindow(item.city.lng, item.city.lat);  
          marker.addEventListener('click', function(e) {
            if(_this.fwInfowindow.length != 0){
              _this.fwInfowindow.forEach((item,index)=>{
                _this.fwInfowindow[index].infowindow.close()
              })			        		
            }
            if(_this.xsInfowindow.length != 0){
              _this.xsInfowindow.forEach((item,index)=>{
                _this.xsInfowindow[index].infowindow.close()
              })			        		
            }			 
            var infowindow = new BMap.InfoWindow(content(item),opts);	
            _this.mapNode.openInfoWindow(infowindow,new BMap.Point(e.point.lng, e.point.lat));       	
            // infowindow.open(map, marker);
            // _this.mapNode.openInfoWindow(infowindow,point);
          });
          _this.fuwushangMarker.push({marker})
          // _this.fwInfowindow.push({infowindow})
        })
        //星使标记
        this.countryDetail.citydetails.forEach(item => {
          if(item.providers.length == 0) return
            item.providers.forEach(xs => {
              var opts = {
                width : 150,     
                height: 80,  
                enableMessage:true
              };
              var point = new BMap.Point(xs.lng, xs.lat);
              var marker = new BMap.Marker(point);
              _this.mapNode.addOverlay(marker);
              marker.addEventListener('click', function(e) {
                if(_this.fwInfowindow.length != 0){
                  _this.fwInfowindow.forEach((item,index)=>{
                    _this.fwInfowindow[index].infowindow.close()
                  })			        		
                }				        	
                if(_this.xsInfowindow.length != 0){
                  _this.xsInfowindow.forEach((item,index)=>{
                    _this.xsInfowindow[index].infowindow.close()
                  })			        		
                }				    
                var infowindow = new BMap.InfoWindow(content1(item),opts);    	
                // infowindow.open(map, marker);
                _this.mapNode.openInfoWindow(infowindow,new BMap.Point(e.point.lng, e.point.lat));
              });	
              _this.xingshiMarker.push({marker})
              // _this.xsInfowindow.push({infowindow})
            })
        })		       
			},
			getRoute(){
				this.navShow=true;
				this.detailsShow=true;
				console.log(this.coldId)
				this.setCenter(this.coldId)
			},
			checkMack(index){
        // var map = this.mapNode;
				this.activeIndex=index;
        this.fuCoordinates()
				if(index == 1){//清除星使					
					this.xingshiMarker.forEach((item,index)=>{
            //this.xingshiMarker[index].map.setMap(null)
            this.mapNode.removeOverlay(this.xingshiMarker[index]);
            
					})						
				}else if(index == 2){
					this.fuwushangMarker.forEach((item,index)=>{
            // this.fuwushangMarker[index].marker.setMap(null)
            this.mapNode.removeOverlay(this.fuwushangMarker[index]);
					})						
				}
			}
		},
		watch: {
      $route(){
        if(this.$route.query.id != undefined){
          this.coldId =JSON.parse(this.$route.query.id)   		      		
        }
      },
      coldId(){
        this.getRoute()
      }
		}
	}
</script>
<style>	
	body, html{zoom: 1;height: 100%;width: 100%;}
	#app{height: 100%;width: 100%;}
</style>
<style scoped="scoped">	
	* {box-sizing: border-box;}
	.mapBox{width: 100%;height: 100%;}
	.map{width: 100%;height: 100%;position: relative;color: #333;}
	.map >.mapGoogle{height: 100%;width: 100%;}
	.map .nav{width: 310px;background: white;position: absolute;top: 0;left: 0;transition:all 0.5s;height: 100%;}
	.map .nav h3{font-weight: normal;font-size: 16px;line-height: 50px;text-align: center;border-bottom: 1px solid #eee;border-right: 1px solid #eee}
	.map .nav li{background: #f7f7f8;}
	.map .nav li .guangjiaList{padding-bottom: 1px;}
	.map .nav li .listBox{padding:10px;overflow: hidden;border-bottom: 1px solid #eee;background: white;}
	.map .nav li .listBox p{float: left;font-size: 14px;}
	.map .nav li .listBox img{float: right;cursor: pointer;height: 19px;transition:all 0.2s}
	.map .nav li .guojia{padding: 15px;margin: 15px;background: #fff;box-shadow: 0 0 10px rgba(0,0,0,0.3);}
	.top{overflow: hidden;}
	.top >img{float: left;width: 60px;height: 50px;}
	.top >.zhishu{float: left;margin-left: 15px;font-size: 14px;color: #666;margin-top: 5px;}
	.top >.zhishu p:nth-child(2){margin-top: 5px;}
	.top >.zhishu .text{font-size: 12px;vertical-align: middle;}
	.top >.zhishu .xing img{height: 14px;display: inline-block;vertical-align: middle;}
	.fuwushang{overflow: hidden;font-size: 14px;margin-top: 15px;}
	.fuwushang p{line-height: 25px;}
	.fuwushang p:first-child{float: left;color: #666;padding-left: 25px;}
	.fuwushang p:last-child{float: right;color: #00abf9;}
	.fuwushang p.icon1{background: url(./img/fuwushang.png) no-repeat left center;background-size: 20px;}
	.fuwushang p.icon2{background: url(./img/xingshi.png) no-repeat left center;background-size: 20px;}
	.height{height: calc(100% - 51px);overflow-y: auto;border-right: 1px solid #eee;}
	.map .nav li .listBox .active{transform: rotate(90deg);margin-right: 5px;}
	.btn{position: absolute;top: 80px ;right: -30px;color: #666;width: 30px;background: white;font-size: 14px;text-align: center;padding: 5px;cursor: pointer;}
	.back{background: url(./img/back.png) no-repeat 20px center;background-size: 20px;font-size: 14px;padding: 10px 20px;padding-left: 45px;border-bottom: 1px solid #eee;cursor: pointer;}
	.detailsBox .box{padding: 20px;}
	.fuwushang p span{color: #00abf9;}
	.fuwushangBox{margin-top: 30px;padding-bottom: 10px;}
	.fuwushangBox.active{border-bottom: 2px solid #00ABF9;}
	.fuwushangBox >p{font-size: 14px;color: #999;margin-bottom: 5px;}
	.fuwushangBox .fuwushang{margin-top: 0;}
	.liebiaoBox{position: absolute;top: 20px;right: 20px;width: 130px;height: 40px;background: white;}
	.liebiaoBox p{background: url(./img/list.png) no-repeat 20px center;background-size: 20px;text-indent: 50px;line-height: 40px;font-size: 14px;color: #999;cursor: pointer;}
	.positionBottom{position: absolute;left: 0;bottom: 0;width: 100%;}
	.promptBox p{color: red;}
</style>
<style>
	.promptBox .top{overflow: hidden;}
	.promptBox .top *{float: left;}
	.promptBox .top img{width: 40px;height: 25px;}
	.promptBox .top p{line-height: 25px;font-size: 12px;margin-left: 5px;min-width: 60px;}
	.promptBox .icon{margin-top: 10px;font-size: 12px;}
	.promptBox .icon span{line-height: 20px;padding: 3px 0;}
	.promptBox .icon span:first-child{background: url(./img/fuwushang.png) no-repeat left center;background-size: 15px;padding-left: 15px;}
	.promptBox .icon span:nth-child(2){background: url(./img/xingshi.png) no-repeat left center;background-size: 15px;padding-left: 15px;margin-left: 10px;}
	.promptBox .icon a{margin-left: 10px;color: #00abf9;text-decoration: none;padding: 3px 0;}
	.gm-style-mtc ,.gm-svpc{display: none;}
	.gm-control-active,.gm-fullscreen-control{display: none;}
	.promptBox .fuWu{color: #333;}
	.promptBox ul li{overflow: hidden;margin-top: 5px;}
	.promptBox ul li .fuImg{float: left;width: 50px;height: 30px;}
	.promptBox ul li .fuName{float: left;margin-left: 5px;width: 100px;}
	.promptBox ul li .fuName p{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;}
	.promptBox ul li .xsImg{float: left;width: 35px;height: 35px;border-radius: 35px;}
	.promptBox ul li .xstext{float: left;line-height: 35px;margin-left: 5px;}
	.promptBox .details{background: url(./img/details.png) no-repeat right center;background-size: 6px;padding-right: 10px !important;}
</style>


// WEBPACK FOOTER //
// src/views/map/index.vue